import React, { FC, ReactNode } from "react";
import { uploadError } from "../../assets/images";
import Button, { ButtonModeE } from "../../components/Button/Button";
import { P } from "../../components/Text/Text";
import usePopup from "../../utils/hooks/usePopup";

import styles from "./fileUploaderError.module.scss";

type FileUploadErrorPropTypes = {
  wrongLength: boolean;
  errorMessage?: string | boolean;
  children?: ReactNode;
};

const FileUploadError: FC<FileUploadErrorPropTypes> = (props) => {
  const { wrongLength, errorMessage, children } = props;
  const wrongAdIdError =
    "Some file(s) cannot be added for upload as they have names that don't match the required AD-ID(s).";
  const wrongLengthError =
    "Note, the video you uploaded is not the exact framed as was required. Are you sure you want to send it?";

  return (
    <div className={styles.popupBody}>
      <img src={uploadError} alt="File upload error" />
      {children || (
        <P>
          {errorMessage || (wrongLength ? wrongLengthError : wrongAdIdError)}
        </P>
      )}
    </div>
  );
};

export default FileUploadError;
